import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    base: "mobile",
    routes: [
        // { path: "/newPay", name: "newPay", component: () => import("@/components/pages/newPay") },
        // //临时使用的主页 23-03-01
        // { path: "/newHome", name: "newHome", component: () => import("@/components/pages/newHome") },
        // //临时使用的报名23-03-01新增
        // { path: "/enroll", name: "newEnroll", component: () => import("@/components/pages/enroll") },
        // 学校简介
        { path: "/", name: "home", component: () => import("@/components/pages/home") },
        // 预报名
        { path: "/register", name: "preRegister", component: () => import("@/components/pages/preRegister/index"), meta: { title: "预报名" } },
        // 查询预缴费
        { path: "/pay", name: "pay", component: () => import("@/components/pages/pay/index") },
        // 触发微信缴费
        { path: "/pay/wxPay", name: "wxPay", component: () => import("@/components/pages/pay/wxPay") },
        // 查询旧生缴费
        { path: '/pay/old', name: 'oldStuPay', component: () => import("@/components/pages/pay/oldStuPay") },
        // 触发旧生微信缴费
        { path: "/pay/wxPay/old", name: "wxPay", component: () => import("@/components/pages/pay/wxPayOld") },
        // 报名信息
        { path: "/registerInfo/:idCard", name: "registerInfo", component: () => import("@/components/pages/register/registerInfo") },
        // 预缴费
        { path: "/pay", name: "prePay", component: () => import("@/components/pages/register/registerInfo") },
        // 我的录取通知书
        { path: "/adviceNote", name: "adviceNote", component: () => import("@/components/pages/pay/adviceNote") },
        //收据管理---新生
        { path: "/seeReceipt", name: "seeReceipt", component: () => import("@/components/pages/pay/seeReceipt") },
        // 我的缴费收据--新生
        { path: "/payReceipt", name: "payReceipt", component: () => import("@/components/pages/pay/payReceipt") },
        //收据管理---旧生
        { path: "/seeOldReceipt", name: "seeOldReceipt", component: () => import("@/components/pages/pay/seeOldReceipt") },
        // 我的缴费收据--旧生
        { path: "/payOldReceipt", name: "payOldReceipt", component: () => import("@/components/pages/pay/payOldReceipt") },
        //  浏览器打开支付宝支付--新生
        { path: "/alipayPay", name: "alipayPay", component: () => import("@/components/pages/alipay/alipayPay") },
        //  浏览器打开支付宝支付---旧生
        { path: "/alipayOldPay", name: "alipayOldPay", component: () => import("@/components/pages/alipay/alipayOldPay") },
        //  支付成功
        { path: "/paymentSuccess", name: "paymentSuccess", component: () => import("@/components/pages/pay/paymentSuccess") },
        // 疫情上报系统
        { path: "/epidemic", name: "epidemicMain", component: () => import("@/components/pages/epidemic/main"), meta: { title: "疫情上报监测系统" } },
        // 首次登记
        { path: "/epidemic/firstRegistration", name: "firstRegistration", component: () => import("@/components/pages/epidemic/firstRegistration") },
        // 每日打卡
        { path: "/epidemic/dailyClock", name: "dailyClock", component: () => import("@/components/pages/epidemic/dailyClock") },
        // 个体病例
        { path: "/epidemic/individualCases", name: "individualCases", component: () => import("@/components/pages/epidemic/individualCases") },
        //来访登记
        { path: "/visitRegist/regist", name: "regist", component: () => import("@/components/pages/visitRegist/regist") },
        //预约登记（用户）
        { path: "/visitRegist/userVisit", name: "userVisit", component: () => import("@/components/pages/visitRegist/userVisit") },
        //预约登记（用户查看）
        { path: "/visitRegist/visitorInfo", name: "visitorInfo", component: () => import("@/components/pages/visitRegist/visitorInfo") },
        //预约登记表（保安）
        { path: "/guard/seeVisitorIndex", name: "seeVisitorIndex", component: () => import("@/components/pages/guard/seeVisitorIndex") },
        //未登记（保安）
        { path: "/guard/registInfo", name: "registInfo", component: () => import("@/components/pages/guard/registInfo") },
        //已登记（保安）
        { path: "/guard/leave", name: "leave", component: () => import("@/components/pages/guard/leave") },
        //来访审批列表
        { path: "/approval/approval", name: "approval", component: () => import("@/components/pages/approval/approval") },
        //来访审批详情
        { path: "/approval/approvalInfo", name: "approvalInfo", component: () => import("@/components/pages/approval/approvalInfo") },
        // 订单管理
        // {path: '/indentManage',name: 'indentManage',component: () =>import("@/components/pages/indentManage/index")},
        // //订单详情
        // {path: '/orderDetails',name: 'orderDetails',component: () => import("@/components/pages/indentManage/orderDetails")},
        //接单管理登录
        { path: '/login', name: 'login', component: () => import("@/components/pages/login/index") }
    ]
});
// Router.afterEach((to, from, next) => {
//   //配置jssdk
//    if(util.isWechat()) {
//      wxsdk.config();
//    }
// });

//  export default Router;



// WEBPACK FOOTER //
// ./src/router/index.js